import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { EngineeringService } from 'src/app/services/engineering/engineering.service';
import { Vendordrawing } from 'src/app/model/vendordrawing.model';
import { NgForm } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ElementRef, ViewChild } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-assigndrawing',
  templateUrl: './assigndrawing.component.html',
  styleUrls: ['./assigndrawing.component.css']
})
export class AssigndrawingComponent implements OnInit {

  @ViewChild('commnt', { static: false }) commnt: ElementRef;
  @ViewChild('fileInput', { static: true }) fileInput: ElementRef;

  stepno: string;
  vendorDrawingData: any;
  vendorDrawing: Vendordrawing;

  form: FormGroup;
  drawingDocs: any;
  drawingComments : any;
  isIntitialValue : boolean = true;
  readonly rootUrl = environment.baseUrl;

  constructor(private engineeringServices: EngineeringService, private router: Router,
    private route: ActivatedRoute, private fb: FormBuilder) {
    this.stepno = this.route.snapshot.params.mdlid;
    this.form = this.fb.group({
      avatar: null
    });
  }

  ngOnInit() {
    this.getMdlById();
    this.getDrawingComments();
  }

  getMdlById() {
    this.engineeringServices.GetMdlById(this.stepno).subscribe(
      data => {
        this.vendorDrawingData = data;
        this.vendorDrawing = this.vendorDrawingData;
        console.log(this.vendorDrawing);
        this.getDrawingDocs();
      }
    )
  }

  commentdraw(commentData: string, drawId: string) {

    console.log(commentData);
    console.log(drawId);
    console.log(this.vendorDrawing);

    if (commentData != null && commentData.trim().length != 0) {
      let input = new FormData();

      input.append('drawingLibId', drawId);
      input.append('query', commentData);
      input.append('poNumber', this.vendorDrawing.poNo);
      input.append('project', this.vendorDrawing.project);
      input.append('customerNo', this.vendorDrawing.customerDrawingNo);
      input.append('customer', this.vendorDrawing.customer);
      input.append('vendorNo', this.vendorDrawing.vendorNo);
      input.append('vendorName', this.vendorDrawing.vendorName);
      input.append('mdlNo', this.vendorDrawing.mdlNo);
      input.append('mdlItemNO', this.vendorDrawing.mdlItemNo);
      input.append('drawingNameL', this.vendorDrawing.description);
      input.append('vendorVersion', this.vendorDrawing.vendorDrawingNo);
      input.append('customerRevision', this.vendorDrawing.customerDrawingNo);
      input.append('mdlListId', this.stepno);
      input.append('queryBy','Admin');

      if (this.vendorDrawing.vendorNo != null && this.vendorDrawing.vendorNo != "") {
        this.engineeringServices.submitDrawingComments(input).subscribe(
          (data: any) => {
            this.commnt.nativeElement.value = "";
            this.getDrawingComments();
            alert("Comment Submitted");
          });
      }
      else {
        alert("Vendor No can't be blank");
      }
    }
    else {
      alert("Please write a comment");
    }


  }



  SubmitAssignForm(form: NgForm) {
    console.log(form.value);
    form.value.mdlListId = this.vendorDrawing.id;

    this.engineeringServices.AssignDrawingVendor(form.value).subscribe(
      data => {
        console.log(data);
        alert("Successfully Assigned");
      }
    )

  }

  onFileChange(event) {
    //alert("selected");
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      this.form.get('avatar').setValue(file);

      console.log(this.form.get('avatar').value);
    }
  }

  uploadDocument() {
    let input = new FormData();
    input.append('avatar', this.form.get('avatar').value);
    input.append('poNo', this.vendorDrawing.poNo);
    input.append('mdlNo', this.vendorDrawing.mdlNo);
    input.append('uploadedBy', "admin");
    input.append('mdlLineItem', this.vendorDrawing.mdlItemNo);
    input.append('isInitial', "true");

    this.engineeringServices.UploadDrawingDocument(input).subscribe(
      (data: any) => {
        if (data == true) {
          this.getDrawingDocs();
          this.form.reset();
          this.fileInput.nativeElement.value = null;
        }
        else {

        }
      }
    );
    
  }

  getDrawingDocs() {
    let inputs = new FormData();
    inputs.append('poNo', this.vendorDrawing.poNo);
    inputs.append('mdlNo', this.vendorDrawing.mdlNo);
    inputs.append('mdlLineItem', this.vendorDrawing.mdlItemNo);

    this.engineeringServices.GetInitialDrawingDocs(inputs).subscribe(
      (data: any) => {
        this.drawingDocs = data;
        console.log(this.drawingDocs);
      }
    );
  }

  removeDoc = function (id) {
    this.engineeringServices.RemoveDrawingDocs(id).subscribe(
      (data: any) => {
        if (data == true) {
          this.getDrawingDocs();
        }
        else {

        }
      }
    );
  }

  getDrawingComments()
  {
    this.engineeringServices.getDrawingComments("null",this.stepno).subscribe(
      (data : any) => {
        this.drawingComments = data;
        console.log(this.drawingComments);
      }
    )
  }

}
